import { APIEndpoints } from "@/utils/APIEndpoints";
import { riccAPI } from "./APIService";

riccAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Change Password
    changePasswordFromProfile: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.changePasswordFromProfile,
        method: "POST",
        body: payload,
      }),
    }),
    // Retrieve Contact Information
    getContactInfoForProfile: builder.query({
      query: () => APIEndpoints.getContactForProfile,
      providesTags: ["contactInfo"],
    }),
    // Update Contact Information
    updateContactInfoForProfile: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.updateContactInfoForProfile,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["contactInfo"],
    }),
    // Get Accessor Details
    getAccessorDetails: builder.query({
      query: () => APIEndpoints.getAccessorDetails,
    }),
    // Get Accessor Transaction Info
    getAccessorTransactionInfo: builder.query({
      query: (operatorId) => ({
        url: APIEndpoints.getAccessorTransactionInfo,
        method: "GET",
        headers: {
          operatorId: operatorId,
        },
      }),
      providesTags: ["updateAccessProfile", "updateOperator", "approveProfile"],
    }),
    // Get Operator Privileges
    getAccessorPrivileges: builder.query({
      query: (accessProfileId) => ({
        url: APIEndpoints.getAccessorPrivileges,
        method: "GET",
        headers: {
          accessProfileId: accessProfileId,
        },
      }),
    }),
    // Get All Access Profile Types
    getAllAccessProfilesForProfile: builder.query({
      query: () => APIEndpoints.getAllAccessProfilesForProfile,
    }),
    // Get Access Profile based on Operator ID
    getAccessProfileForProfile: builder.query({
      query: (operatorId) => ({
        url: APIEndpoints.getAccessProfileForProfile,
        method: "GET",
        headers: {
          operatorId: operatorId,
        },
      }),
      keepUnusedDataFor: 0,
      providesTags: ["updateAccessProfile"],
    }),
    // Update Access Profile
    updateAccessProfileForProfile: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.updateAccessProfileForProfile,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["updateAccessProfile"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useChangePasswordFromProfileMutation,
  useGetContactInfoForProfileQuery,
  useUpdateContactInfoForProfileMutation,
  useGetAccessorDetailsQuery,
  useLazyGetAccessorTransactionInfoQuery,
  useGetAccessorTransactionInfoQuery,
  useLazyGetAccessorPrivilegesQuery,
  useGetAllAccessProfilesForProfileQuery,
  useGetAccessProfileForProfileQuery,
  useUpdateAccessProfileForProfileMutation,
  useInsurersMutation,
} = riccAPI;
